module.exports = __webpack_public_path__ + "img/dlx-on.c0e6f209.svg";